import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
 
@Component({
  selector: 'app-calendar-year-detail-date',
  templateUrl: './calendar-year-detail-date.component.html',
  styleUrls: ['./calendar-year-detail-date.component.css']
})
export class CalendarYearDetailDateComponent implements OnInit {

  public title: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {

    console.log(data);
 
    //data.JulianDateBritishObserved = "1-1-2000";
     
    this.title = data.LongDateStr;
     

  }
  
  ngOnInit() { 
  }

}
